import {Injectable} from '@angular/core';
import {AuthStorage} from '../core/auth/auth-storage';
import {GlobalService} from '../core/global/global.service';

const isWebview = require("is-ua-webview");

@Injectable()
export class WebviewAuthService {

  constructor(private globalService: GlobalService) {
  }

  public loadTokensFromCookies(): Promise<void> {
    return new Promise((resolve) => {
      if (isWebview(navigator.userAgent)) {
        let accessToken = this.parseCookies('fhw_auth_token');
        let refreshToken = this.parseCookies('fhw_refresh_token');
        if (WebviewAuthService.isNotBlank(accessToken) && WebviewAuthService.isNotBlank(refreshToken)) {
          AuthStorage.persistTokens(accessToken, refreshToken);
          this.globalService.getLoginDetails().subscribe({
            next: (loggedUser) => {
              AuthStorage.updateUserSettings(loggedUser, true);
              resolve();
            },
            error: () => resolve()
          });
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  }

  private parseCookies(cookieName: string): string | null {
    const match = document.cookie.match(
      new RegExp('(?:^|; )'
        + cookieName.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1')
        + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  private static isNotBlank(string: string) {
    return string != null && string.length > 0;
  }

}
